<template>
  <div class="parent">
  <div class="box">
      <BInputDateRange
        v-model="createTime"
        from-text="创建时间"
        to-text="至"
        @startDateChange="startDateChange"
        @endDateChange="endDateChange"
      />
      <BInputText
        label-text="关键字"
        v-model="searchParam.createName"
        placeholder="名称/创建人"
      />
      <BBtnSecondary
        :img-src="require('@/assets/filter.png')"
        :clicked="doSearch"
        hidden-key="true"
        btn-txt="筛选"
        style="margin-left: 30px;"
      />
    </div>
    <div class="search-result">
      <div class="search-functions-headers">
        <div class="search-functions">
          <BBtnPrimary
            :img-src="require('@/assets/new.png')"
            :clicked="courseFileAdd"
            v-if="editFlag == 'false'"
            btn-txt="添加资料"
          />
        </div>
      </div>
      <Table
        :headers="headers"
        :tableData="fileList"
        :length="totalPages"
        :total-visible="7"
        :page-num="page"
        v-model="page"
        @input="doSearch(false)"
      >
        <template v-slot:actions="item">
          <div style="display:flex;flex-direction:row;justify-content: center;">
            <div class="btn-detail" @click="download(item.data)">
              下载
            </div>
            <div class="btn-delete" @click="fileDelete(item.data.id)">
              删除
            </div>
          </div>
        </template>
      </Table>
    </div>
        
  </div>
</template>
<script>
import { searchList, fileDelete,fileSave ,saveDownloadNum} from "@/api/courseFile";
import BInputDateRange from "../../components2/BInputDateRange";
import BInputText from "../../components2/BInputText";
import BBtnSecondary from "../../components2/BBtnSecondary";
import Table from "../../components2/Table";
import BBtnPrimary from "../../components2/BBtnPrimary";
import CourseFileAdd from "../../views2/sample/CourseFileAdd";
import Hub from '../../events/Hub';
import PopupContents from "../../views2/sample/PopupContents";
import Vue from "vue";
import axios from "axios";
export default {
  /* 父子组件传参 data中定义的参数不能与props中定义的参数名一致 */
  props: ["courseId"],
  components: {
    Table,
    BInputText,
    BBtnSecondary,
    BBtnPrimary,
    BInputDateRange,
  },
  data() {
    return {
      editFlag: sessionStorage.getItem("editFlag").toString(),
      createTime: {
        from: "",
        to: "",
      },
      totalPages: 0,
      page: 1,
      limit: 10,
      totalCount: 0,
      selected: [],
      singleSelect: false,
      loading: false,
      landscape: true,
      menu1: false,
      menu2: false,
      data_courseId: "",
      searchParam: {
        startDate: "",
        endDate: "",
        createName: "",
      },
      headers: [
        { text: "ID", value: "indexNum", sortable: false, align: "center", width: '4%' },
        { text: "文件名", value: "fileName", sortable: false, width: '30%' },
        { text: "下载量", value: "downloadNum", sortable: false, align: "center", width: '15%' },
        { text: "创建人", value: "createUserName", sortable: false, align: "center", width: '15%' },
        { text: "创建时间", value: "createTime", sortable: false, align: "center", width: '15%' },
        { text: "操作", value: "actions", sortable: false, align: "center" },
      ],
      // 上传dialog
      uploadDialog: false,
      // 删除dialog
      deleteDialog: false,
      // 文件list
      fileList: [],
      // 文件id
      fileId: null,
      data:{},
      // 文件保存list
      fileSaveList:[],
      deleteId:'',
      // 下载量
      downloadNum: null,
      navi: [
        {name: "course-management"},
        {name: "course_file"},
      ],
    };
  },
  mounted() {
    this.$store.commit('SET_NAVI_DATA', this.navi);
    if (this.$props.courseId !== null && this.$props.courseId !== undefined) {
      this.data_courseId = this.$props.courseId;
      this.doSearch(true);
    }
    this.$nextTick(
      function() {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
  },
  methods: {
    // 下载
    download(data) {
      if(!data){
        return
      }
      let link = document.createElement('a')
      axios.get(data.fileUrl,{
        responseType: 'blob',
      }).then(res=>{
        let blob = new Blob([res.data])
        let objUrl = URL.createObjectURL(blob)
        link.href = objUrl
        link.download = data.fileName
        link.click()
        URL.revokeObjectURL(objUrl)
      })
      this.fileId = data.id
      if(data.downloadNum===null){
        this.downloadNum = 0
      }else{
         this.downloadNum = data.downloadNum
      }
      this.saveDownloadNum()
    },
    // 下载量添加
    async saveDownloadNum(){
      var params = {
        id :this.fileId,
        downloadNum: this.downloadNum +1
      }
      const data  = await saveDownloadNum(params)
       if (data.code === 0) { 
        Vue.prototype.$vsnackbar.show(data.msg);
        this.doSearch(true);
      } else {
        Vue.prototype.$vsnackbar.show(data.msg);
      }
    },
    // 添加资料按钮
    courseFileAdd() {
      Hub.$emit('open-modal');
      Hub.$emit('set-modal-data', this.data, '添加资料', CourseFileAdd);
    },
    // 确认删除
    async delConfirm(id) {
      var param = {
        id: id,
      };
      const data = await fileDelete(param);
      if (data.code === 0) { 
        Vue.prototype.$vsnackbar.show(data.msg);
        this.doSearch(true);
      } else {
        Vue.prototype.$vsnackbar.show(data.msg);
      }
    },
    // 删除文件
    async fileDelete(id) {
      this.data.bodyText = "确认删除该资料吗？";
      this.deleteId = id;
      Hub.$emit("open-modal");
      Hub.$emit("set-modal-data", this.data.bodyText, "删除", PopupContents);
    },
    // 查询
     doSearch(flag) {
      if (flag) {
          this.totalPages = 0
          this.page = 1
          this.limit = 10
          this.totalCounts = 0
        }
         this.searchList()
    },
    async searchList (){
      this.loading = true;
      var param = {
        page: this.page,
        limit: this.limit,
        startDate: this.createTime.from,
        endDate: this.createTime.to,
        createName: this.comUtils.trim(this.searchParam.createName),
        courseId: this.data_courseId,
      };
      const data = await searchList(param);
      if (data.data.searchList !== null || data.data.searchList === "") {
        this.fileList = data.data.searchList;
      }
      this.courseHoursTotal = data.data.courseHoursTotal;
      this.courseNum = data.data.courseNum;
      this.totalCount = data.data.totalPage;
      this.totalPages = Math.ceil(this.totalCount / this.limit);
      this.loading = false;
    },

    startDateChange(value) {
      this.createTime.from = value;
    },
    endDateChange(value) {
      this.createTime.to = value;
    },
    // 文件保存
    async fileSave(fileList){
      for(var dao of fileList){
        dao.courseId = this.data_courseId
      }
      var params = {
        fileSaveList:this.fileSaveList
      }
      const data = await fileSave(params)
      if(data.code === 0){
        Vue.prototype.$vsnackbar.show(data.msg);
        this.doSearch(true);
      }else{
        Vue.prototype.$valertbar.show(data.msg);
      }

    },
   set(value) {
      console.info("value = ",value);
      if (value === 1) {
            // 成功 页面刷新
            this.delConfirm(this.deleteId)
       } else {
         if (value== null || value.length==0) {
           Vue.prototype.$valertbar.show("上传失败");
           return;
         } else {
           this.fileSaveList = value
           // 成功 添加文件
           this.fileSave(this.fileSaveList)
         }
       }
    },
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
};
</script>

<style scoped>
.main2 {
  position: relative;
  /*margin: 5px 30px 5px 30px;*/
  padding-top: 28px;
  display: flex;
  flex-wrap: wrap;
}

.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  top: 0;
}

.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.search-result-summary {
  display: flex;
  align-items: center;
}

.search-result-summary .summary {
  margin: 0 50px 0 0;
}

.search-result-table {
  border-spacing: 0px;
  padding-bottom: 50px;
  width: 100%;
  margin-top: 10px;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  color: #fd1f58;
  cursor: pointer;
}
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
a {
  text-decoration: none;
}
  .parent {
    margin-top: 1.5em;
  }
</style>
